const currencyOptions: { [key: string]: string } = {
  Business: 'Business',
  Individual: 'Individual',
};

export default currencyOptions;
